import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_TWB_DASHBOARD = gql`
  query GetTWBDashboard($clientId: String) {
    getTWBDashboard(clientId: $clientId) {
      sheets {
        sheetId
        featureTag
      }
      url
      parameters
    }
  }
`;
